import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "flex xs8" }
const _hoisted_3 = ["onClick"]

import { UserChannel } from "@/models/Channel";
import { computed, getCurrentInstance, ref, toRefs } from "vue";
import InlineEdit from "@/components/InlineEdit.vue";

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  props: {
  userChannel: { type: UserChannel, required: true },
},
  setup(__props) {

const props = __props



const providerIcon = computed(() => props.userChannel.providerIcon);

const statusPlus = computed(() => {
  return props.userChannel.statusPlus;
});

const name = computed({
  get: () => props.userChannel.name,
  set(newName: string) {
    props.userChannel.set("name", newName);
    props.userChannel.save();
  },
});

const remove = async (): Promise<void> => {
  props.userChannel.destroy().then(
    (myObject: UserChannel): void => {
      console.log("Deleted " + myObject.id);
    },
    (error: Error) => {
      alert("Delete Failed  " + error.message);
    }
  );
};

const statusIcon = ref("done");
const statusIconColor = ref("Primary");

const fetchStatus = async () => {
  const { name: status, color: color } =
    await props.userChannel.statusIconInfo();
  statusIcon.value = status;
  statusIconColor.value = color;
};
fetchStatus();

const app = getCurrentInstance();
const vaToast = app?.appContext.config.globalProperties.$vaToast;
const showToast = vaToast;

const resendVerification = async (data: any): Promise<boolean> => {
  // this is a hack till we can pass the records in.
  await props.userChannel.sendVerification();
  showToast.init({
    message: "Verification Sent",
    duration: 2000,
    color: "success",
  });
  return true;
};

return (_ctx: any,_cache: any) => {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_list_item_section = _resolveComponent("va-list-item-section")!
  const _component_va_list_item_label = _resolveComponent("va-list-item-label")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_list_item = _resolveComponent("va-list-item")!

  return (_openBlock(), _createBlock(_component_va_list_item, null, {
    default: _withCtx(() => [
      _createVNode(_component_va_list_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_va_icon, {
            name: _unref(providerIcon),
            size: 25
          }, null, 8, ["name"])
        ]),
        _: 1
      }),
      _createVNode(_component_va_list_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_va_list_item_label, null, {
            default: _withCtx(() => [
              _createVNode(InlineEdit, {
                modelValue: _unref(name),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_va_list_item_label, { caption: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.userChannel.channelDescription), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_va_list_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_va_list_item_label, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_va_icon, {
                  class: "flex xs3",
                  name: statusIcon.value,
                  color: statusIconColor.value
                }, null, 8, ["name", "color"]),
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_unref(statusPlus)) + " ", 1),
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("a", {
                      style: {"font-size":"smaller"},
                      href: "#",
                      onClick: _withModifiers(resendVerification, ["prevent"])
                    }, "Resend", 8, _hoisted_3)
                  ], 512), [
                    [_vShow, _unref(statusPlus) == 'Verification Sent']
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_va_list_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_va_button, {
            size: "small",
            onClick: remove,
            icon: "delete"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})